export default __webpack_public_path__ + "static/media/MapaInovacaoFig1.72106fa5.svg";